import React from 'react';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import TravelIcon from '@mui/icons-material/CardTravel';
import ChatIcon from '@mui/icons-material/Chat';
import CollectionIcon from '@mui/icons-material/CollectionsBookmark';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import PencilIcon from '@mui/icons-material/Edit';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationIcon from '@mui/icons-material/LocationSearching';
import MovieIcon from '@mui/icons-material/Movie';
import BrowserOpenIcon from '@mui/icons-material/OpenInBrowser';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import IntegrationIcon from '@mui/icons-material/SettingsInputComponent';
import SubscriptionIcon from '@mui/icons-material/Subscriptions';
import TimerIcon from '@mui/icons-material/Timer';
import PipeDriveCustomIcons from '@bbkAdminUtils/icons/custom/pipedrive/pipedrive-icons';
import { ExitSurveyIcons } from '@bbkAdminUtils/icons/funnel-icons';
import { type MapElement } from '@bbkAdminUtils/utility-types';
import Icon from '@bbkFunnelUtils/exit-icon';

type ExitSurveyIconName = MapElement<typeof ExitSurveyIcons>['icon'];
type FunnelIconName = React.ComponentProps<typeof Icon>['name'];
export default function getIconForItem(
  icon: ExitSurveyIconName | FunnelIconName | string,
  fillColor: React.CSSProperties['fill']
) {
  let rtnIcon = '';
  const iconStyles = { color: fillColor, fill: fillColor };
  if (/^bbk-esi-/.test(icon)) {
    return <div style={iconStyles}>{ExitSurveyIcons[icon]?.svg}</div>;
  }

  // TODO: remove all the usage of material icons
  switch (icon) {
    case 'pipedrive-calendar':
      return <div style={iconStyles}>{PipeDriveCustomIcons[icon]}</div>;
    case 'pipedrive-person':
      return <div style={iconStyles}>{PipeDriveCustomIcons[icon]}</div>;
    case 'pipedrive-deal':
      return <div style={iconStyles}>{PipeDriveCustomIcons[icon]}</div>;
    case 'pipedrive-forecast':
      return <div style={iconStyles}>{PipeDriveCustomIcons[icon]}</div>;
    case 'contacts':
      return (
        <Icon name="contacts" classes="bbk-custom-icon" styles={iconStyles} />
      );
    case 'template':
      return (
        <Icon name="columns" classes="bbk-custom-icon" styles={iconStyles} />
      );
    case 'email':
      return (
        <Icon name="airplane" classes="bbk-custom-icon" styles={iconStyles} />
      );
    case 'subscription':
      return <SubscriptionIcon style={iconStyles} />;
    case 'movie':
      return <MovieIcon style={iconStyles} />;
    case 'search':
      return <SearchIcon style={iconStyles} />;
    case 'collection':
      return <CollectionIcon style={iconStyles} />;
    case 'location':
      return <LocationIcon style={iconStyles} />;
    case 'timer':
      return <TimerIcon style={iconStyles} />;
    case 'dashboard':
      return <DashboardIcon style={iconStyles} />;
    case 'location-on':
      return <LocationOnIcon style={iconStyles} />;
    case 'description':
      return <DescriptionIcon style={iconStyles} />;
    case 'chat':
      return <ChatIcon style={iconStyles} />;
    case 'dbl-chat': // Used on drift
      return (
        <Icon name="dblChat" classes="bbk-custom-icon" styles={iconStyles} />
      );
    case 'playbook': // Used on drift
      return (
        <Icon name="playbook" classes="bbk-custom-icon" styles={iconStyles} />
      );
    case 'personD': // Used on drift
      return (
        <Icon name="personD" classes="bbk-custom-icon" styles={iconStyles} />
      );
    case 'local-offer':
      return <LocalOfferIcon style={iconStyles} />;
    case 'live-tv':
      return <LiveTvIcon style={iconStyles} />;
    case 'integration':
      return <IntegrationIcon style={iconStyles} />;
    case 'travel':
      return <TravelIcon style={iconStyles} />;
    case 'money':
      return <MoneyIcon style={iconStyles} />;
    case 'refresh':
      return <RefreshIcon style={iconStyles} />;
    case 'pencil':
      return <PencilIcon style={iconStyles} />;
    case 'open-in-browser':
      return <BrowserOpenIcon style={iconStyles} />;
    default:
      if (icon) {
        return (
          <Icon
            name={icon as FunnelIconName}
            classes="bbk-custom-icon"
            styles={iconStyles}
          />
        );
      }
      return (
        <Icon name="columns" classes="bbk-custom-icon" styles={iconStyles} />
      );
  }
}
